import React, { forwardRef, useImperativeHandle, useRef, useState } from "react";

import { Drawer, Button, Row, Col, Divider } from "antd";

import SurgicalInterventionSummary from "../surgical_intervention/SurgicalInterventionSummary";
import TransfersInterventionTable from "./TransfersInterventionTable";
import TransferInterventionForm from "./TransferInterventionForm";

const TransferIntervention = forwardRef((props, ref) => {
  const { surgicalIntervention } = props;
  const transfersInterventionRef = useRef(null);
  const [selectedTransferInterventionId, setSelectedTransferInterventionId] = useState(null);
  const [showTransferInterventionForm, setShowTransferInterventionForm] = useState(false);

  /**
   *
   */
  const onClose = () => {
    props.onClose();
  };

  /**
   * 
   */
  const showTransferInterventionFormHandler = () => {
    setShowTransferInterventionForm(true);
  }

  /**
   * 
   */
  const hideTransferInterventionFormHandler = () => {
    setSelectedTransferInterventionId(null);
    setShowTransferInterventionForm(false);
  }

  /**
   * 
   */
  const onFinishTransferIntervention = () => {
    transfersInterventionRef.current.fetch({
      current: 1,
      pageSize: 10,
    });

    setShowTransferInterventionForm(false);
    setSelectedTransferInterventionId(null);

    props.onChange();
  }

  /**
   * 
   * @param {*} id
   */
  const onEditTransferInterventionHandler = (id) => {
    setSelectedTransferInterventionId(id);
    setShowTransferInterventionForm(true);
  }
  
  /**
   * 
   * @param {*} ref
   */
  useImperativeHandle(ref, () => ({
    fetch: () => {
      fetch();
    },
  }));

  if (surgicalIntervention === null) {
    return null;
  }

  return (
    <Drawer
      width={800}
      title="Transferts patient"
      placement="left"
      visible={props.visible}
      onClose={onClose}
      footer={
        <div style={{ textAlign: "right" }}>
          <div>
            <Button onClick={onClose} type="primary">
              Fermer
            </Button>
          </div>
        </div>
      }
    >
      <SurgicalInterventionSummary surgicalIntervention={surgicalIntervention} />
      <Divider />
      <Row style={{ textAlign: "right" }}>
        <Col span={24}>
          <Button
            key="add"
            type="primary"
            size="large"
            style={{ marginBottom: "20px" }}
            onClick={showTransferInterventionFormHandler}
          >
            Nouveau transfert
          </Button>
        </Col>
      </Row>
      <TransfersInterventionTable
        ref={transfersInterventionRef}
        surgicalIntervention={surgicalIntervention}
        onEdit={onEditTransferInterventionHandler}
      />
      <TransferInterventionForm
        visible={showTransferInterventionForm}
        surgicalIntervention={surgicalIntervention}
        transferInterventionId={selectedTransferInterventionId}
        onClose={hideTransferInterventionFormHandler}
        onFinish={onFinishTransferIntervention}
      />
    </Drawer>
  );
});

export default TransferIntervention;
